import React from 'react';
import { t } from '../../../../../i18n';
import { handshakeIcon, placeLocationIcon, userWithMessageIcon } from '../../../../assets/index';
import './styles.scss';

const InformatinalBlock = () => {
  return (
    <div className="home-screen__informational-block">
      <div className="home-screen__informational-block-content-wrapper">
        <div className="home-screen__static-information-unit">
          <div>
            <img src={userWithMessageIcon} alt="user-with-message" />
          </div>
          <b>{t('DIGITAL_COURSES.HOME_SCREEN.ADDITIONAL_INFO.EXCLUSIVE_COURSES_TITLE')}</b>
          <p>{t('DIGITAL_COURSES.HOME_SCREEN.ADDITIONAL_INFO.EXCLUSIVE_COURSES_DESCRIPTION')}</p>
        </div>
        <div className="home-screen__static-information-unit">
          <div>
            <img src={handshakeIcon} alt="handshake" />
          </div>
          <b>{t('DIGITAL_COURSES.HOME_SCREEN.ADDITIONAL_INFO.PROFESSIONAL_KNOWLEDGE_TITLE')}</b>
          <p>{t('DIGITAL_COURSES.HOME_SCREEN.ADDITIONAL_INFO.PROFESSIONAL_KNOWLEDGE_DESCRIPTION')}</p>
        </div>
        <div className="home-screen__static-information-unit">
          <div>
            <img src={placeLocationIcon} alt="place-location" />
          </div>
          <b>{t('DIGITAL_COURSES.HOME_SCREEN.ADDITIONAL_INFO.TIME_AND_PLACE_TITLE')}</b>
          <p>{t('DIGITAL_COURSES.HOME_SCREEN.ADDITIONAL_INFO.TIME_AND_PLACE_DESCRIPTION')}</p>
        </div>
      </div>
    </div>
  );
};

export default InformatinalBlock;
